/**
 * Vincent XLSX 2026-07-13 21h Row 451 (Eric 2026-07-14 SPEC STRICK) —
 * Hook partagé pour l'éligibilité au quiz général d'un parcours.
 *
 * États retournés :
 *   - "locked"   (rouge)  : au moins une vidéo du parcours pas encore réussie à ≥ 60 %
 *   - "eligible" (bleu)   : toutes les vidéos réussies mais quiz général pas encore passé
 *   - "passed"   (vert)   : quiz général réussi avec ≥ 60 %
 *
 * Retourne aussi `reason_fr` pour le message informatif du toast lorsque le
 * bouton est cliqué en état "locked".
 */
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API_BASE as API } from "./apiBase";

export function usePathwayQuizEligibility(pathwayId) {
  const [state, setState] = useState({
    loading: true,
    eligibility: null,
    error: null,
  });

  const refetch = useCallback(async () => {
    if (!pathwayId) {
      setState({ loading: false, eligibility: null, error: null });
      return;
    }
    try {
      const { data } = await axios.get(
        `${API}/api/pathways/${pathwayId}/quiz-eligibility`,
        { withCredentials: true }
      );
      setState({ loading: false, eligibility: data, error: null });
    } catch (e) {
      setState({
        loading: false,
        eligibility: null,
        error: e?.response?.data?.detail || e?.message || "Erreur",
      });
    }
  }, [pathwayId]);

  useEffect(() => { refetch(); }, [refetch]);

  return { ...state, refetch };
}

/** Classes Tailwind pour le bouton "Faire le quiz du parcours" selon l'état. */
export function pathwayQuizButtonClasses(eligibilityState) {
  const base = "inline-flex items-center gap-2 px-4 py-2 rounded-lg font-semibold text-xs shadow transition-all";
  switch (eligibilityState) {
    case "passed":
      return `${base} bg-teal-600 hover:bg-teal-700 text-white hover:shadow-lg`;
    case "eligible":
      return `${base} bg-[#002FA7] hover:bg-blue-800 text-white hover:shadow-lg`;
    case "locked":
    default:
      return `${base} bg-rose-600 text-white opacity-90 cursor-not-allowed hover:shadow-none`;
  }
}
